import Vue from 'vue'
import VueAxios from 'vue-axios'
import router from './router'
import App from './App.vue'
import axios from 'axios'
import VueBarcode from '@xkeshi/vue-barcode' // 條碼生成器
import VueClipboard from 'vue-clipboard2' // 複製剪貼
import { DatePicker, LocaleProvider } from 'ant-design-vue' // 日曆時間
import 'ant-design-vue/dist/antd.css' // 日曆時間css
import { library } from '@fortawesome/fontawesome-svg-core' // icon
import { // 引用的icon
  faPlus, faMinus, faSignInAlt, faSignOutAlt, faIdCard,
  faUserGraduate, faUserTie, faUserShield, faDollarSign,
  faAngleDoubleUp, faPrint, faChartBar, faHandHoldingUsd,
  faSearchDollar, faCartPlus, faCloudDownloadAlt, faUserEdit,
  faUserFriends, faUserTimes, faUserSlash, faUserPlus,
  faFileExport, faFileImport, faUserCheck, faCreditCard,
  faDonate, faChalkboardTeacher, faUserCog, faLayerGroup,
  faTimes, faBook, faIdCardAlt, faEdit, faSearch, faUnlockAlt,
  faShoppingCart, faCheckCircle, faExclamationTriangle,
  faSearchMinus, faChevronCircleDown
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { TablePlugin, PaginationPlugin } from 'bootstrap-vue' // 表格、頁碼
import 'bootstrap'
import './registerServiceWorker'
import './bus' // 跨層傳遞資料
import vTitle from '@/components/Features/Title.vue'
import vPage from '@/components/Features/Page.vue'
import vDept from '@/components/Features/Dept.vue'
import vButton from '@/components/Features/Button'
import vInput from '@/components/Features/Input'
import vFont from '@/components/Features/Font'
import vLabel from '@/components/Features/Label'

library.add( // 宣告的icon
  faPlus, faMinus, faSignInAlt, faSignOutAlt,
  faIdCard, faUserGraduate, faUserTie, faUserShield,
  faDollarSign, faAngleDoubleUp, faPrint, faChartBar,
  faHandHoldingUsd, faSearchDollar, faCartPlus, faCloudDownloadAlt,
  faUserEdit, faUserFriends, faUserTimes, faUserSlash, faUserPlus,
  faFileExport, faFileImport, faUserCheck, faCreditCard,
  faDonate, faChalkboardTeacher, faUserCog, faLayerGroup,
  faTimes, faBook, faIdCardAlt, faEdit, faSearch, faUnlockAlt,
  faShoppingCart, faCheckCircle, faExclamationTriangle,
  faSearchMinus, faChevronCircleDown
)
// 全域引用
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component(VueBarcode.name, VueBarcode)
Vue.component('v-title', vTitle) // 元件-標題
Vue.component('v-label', vLabel) // 元件-標題
Vue.component('v-page', vPage) // 元件-筆數
Vue.component('v-Dept', vDept) // 元件-部門
Vue.component('v-button', vButton) // 元件-按鈕
Vue.component('v-input', vInput) // 元件-輸入
Vue.component('v-font', vFont) // 元件-文字
Vue.use(VueAxios, axios)
Vue.use(TablePlugin)
Vue.use(PaginationPlugin)
Vue.use(DatePicker)
Vue.use(LocaleProvider)
Vue.use(VueClipboard)
Vue.config.productionTip = false
axios.defaults.withCredentials = true
VueClipboard.config.autoSetContainer = true
new Vue({
  el: '#app',
  router,
  render: h => h(App)
}).$mount('#app')
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) { // 判斷路徑有無需要驗證
    const MIdentity = JSON.parse(localStorage.getItem('M_Identity')) // localStorage取Token
    const Identity = JSON.parse(sessionStorage.getItem('Identity'))
    const Department = JSON.parse(sessionStorage.getItem('Department'))
    if (MIdentity) {
      if (MIdentity.Token) { // 判斷有無Token
        next()
      } else {
        next({
          path: '/news'
        })
      }
    } else if (Identity) {
      if (Identity.Token) { // 判斷有無Token
        next()
      } else {
        next({
          path: '/admin/login'
        })
      }
    } else if (Department) {
      next()
    } else {
      next({
        path: '/news'
      })
    }
  } else {
    next()
  }
})
